import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  category?: string;
  active?: boolean;
  children?: React.ReactNode;
  onPress?: (category?: string) => void;
}

const AppCategoryChip: FC<Props> = (props) => {
  const { category, active, onPress } = props;

  const handlePress = () => onPress?.(category);

  return (
    <Container active={active} onPress={handlePress}>
      {active ? (
        <>
          <Text>
            <FontAwesomeIcon icon="check" color="rgba(83, 90, 241, 1)" />
          </Text>
          <Spacer width="10px" />
        </>
      ) : null}

      <Label variant="p2" weight="semibold" active={active}>
        {props.children}
      </Label>
    </Container>
  );
};

const Container = styled.TouchableOpacity<{ active?: boolean }>`
  flex-direction: row;
  align-items: center;

  padding: 10px 16px;
  background-color: ${({ active }) =>
    active ? 'white' : 'rgba(248, 255, 255, 0.15)'};
  border-radius: 20px;
`;

const Label = styled(Text)<{ active?: boolean }>`
  color: ${({ active }) => (active ? palette.primary_70 : 'white')};
`;

export default AppCategoryChip;
